import React, { FC, memo } from "react";
import { useTranslation } from "react-i18next";
import { PlaceholderIcon, Wrapper } from "../../../../styles/placeholderStyles";
import placeholderIcon from "../../images/storage-placeholder.svg";

const NoItemsPlaceholder: FC = () => {
  const { t } = useTranslation("common");

  return (
    <Wrapper>
      <PlaceholderIcon
        src={placeholderIcon}
        alt={t("parcels.placeholderIcon")}
      />
    </Wrapper>
  );
};

export default memo(NoItemsPlaceholder);
